<template>
  <div>
    <NavBar />
    <main role="main">
      <div class="container">
        <div class="row">
          <div class="col-md-8">
            <div class="alert alert-info text-center" role="alert">
              É o seu primeiro acesso? Atualize o seu cadastro
              <router-link to="/register">clicando aqui</router-link>.
            </div>
            <div class="row justify-content-center">
              <div class="col-md-6">
                <form @submit.prevent="enviar">
                  <div class="form-group">
                    <div class="text-center">
                      <h5 class="mb-3">Login do Associado</h5>
                    </div>
                    <label>CPF:</label>
                    <input
                      type="text"
                      :disabled="isLoading"
                      class="form-control"
                      :class="{ 'is-invalid': $v.cpf.$error, 'is-valid': !$v.cpf.$invalid }"
                      v-mask="['###.###.###-##']"
                      v-model.trim="$v.cpf.$model"
                      autocomplete="off"
                      placeholder="Informe o seu CPF"
                    />
                    <div class="invalid-feedback">
                      Informe um
                      <strong>CPF</strong> válido.
                    </div>
                  </div>
                  <div class="form-group">
                    <label>Senha:</label>
                    <input
                      type="password"
                      class="form-control"
                      v-model="$v.password.$model"
                      :disabled="isLoading"
                      :class="{ 'is-invalid': $v.password.$error, 'is-valid': !$v.password.$invalid }"
                      autocomplete="off"
                      placeholder="Senha"
                    />
                    <div class="invalid-feedback" v-if="!$v.password.minLength">
                      a sua
                      <strong>senha</strong> deve conter no mínimo 8 caracteres.
                    </div>
                    <div class="invalid-feedback" v-if="!$v.password.required">
                      A
                      <strong>Senha</strong> é obrigatória.
                    </div>
                  </div>
                  <div class="form-group mb-3">
                    <label>
                      <input type="checkbox" v-model="remember" /> Lembrar de mim
                    </label>
                  </div>
                  <button type="submit" class="btn btn-primary btn-block btn-flat mb-3">
                    <span v-if="!isLoading">Login</span>
                    <span v-if="isLoading">
                      <i class="fa fa-circle-o-notch fa-spin"></i> Autenticando...
                    </span>
                  </button>
                  <p>
                    <router-link to="/recuperar">Esqueci a minha senha</router-link>
                    <br />
                  </p>
                  <p>
                    <router-link to="/register">Não tem cadastro? Seja um associado</router-link>
                    <br />
                  </p>
                </form>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <ColunaSocio :showLink="true" />
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import ColunaSocio from "@/components/ColunaSocio.vue";
import { required, minLength } from "vuelidate/lib/validators";
import { validaCpf } from "@/helpers";

const validCPF = value => validaCpf(value);

export default {
  name: "login",
  metaInfo: {
    title: "Login do Associado - Redes de Estudos Rurais"
  },
  data: function() {
    return {
      cpf: "",
      password: "",
      remember: false,
      isLoading: false
    };
  },
  components: {
    NavBar,
    ColunaSocio
  },
  validations: {
    cpf: {
      required,
      validCPF
    },
    password: {
      required,
      minLength: minLength(8)
    }
  },
  methods: {
    enviar() {
      this.$v.$touch();
      if (!this.$v.cpf.$invalid) {
        this.isLoading = true;
        this.$auth.login({
          data: { login: this.cpf, password: this.password },
          success: function(response) {
            this.$toasted.global.defaultSuccess({
              mensagem: response.data.mensagem
            });
          },
          error: function(res) {
            if (res != "Error: Network Error") {
              this.$toasted.global.defaultError({
                mensagem: res.response.data.mensagem
              });
            } else {
              this.$toasted.global.defaultError({
                mensagem:
                  "Não foi possível conectar ao servidor. Verifique a sua conexão e tente novamente."
              });
            }
            this.isLoading = false;
          },
          redirect: "/home"
        });
      }
    }
  }
};
</script>
